export default __webpack_public_path__ + "static/media/DNo.17-2.b13973c7.jpg";